import { fetchRealmOutfitsTags } from 'modules/realm-outfits/reducers/realm-outfits-tags';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { splitTagsByType } from 'utils/realm-outfits';

export function useTags() {
  const dispatch = useDispatch();

  const tags = useSelector((state: any) => state?.realmOutfitsTags?.tags ?? []);
  const tagsByType = splitTagsByType(tags);

  useEffect(() => {
    dispatch(fetchRealmOutfitsTags());
  }, []);

  return tagsByType.gtl;
}
